import React, { Component, ReactNode } from 'react';
import './TensionMeterScale.scss';

interface TensionMeterScaleProps {
  start: number;
  end: number;
  onChange?: (value: number) => void;
  className?: string;
}

interface TensionMeterScaleState {
  selectedIndex: number;
}

export class TensionMeterScale extends Component<TensionMeterScaleProps, TensionMeterScaleState> {
  state = {
    selectedIndex: -1,
  };

  handleSelect = (index: number): void => {
    const currentSelectedIndex = this.state.selectedIndex;
    let newSelectedIndex = index;
    if (currentSelectedIndex === index) {
      newSelectedIndex = -1;
    }
    this.setState({ selectedIndex: newSelectedIndex });
    if (this.props.onChange) {
      if (newSelectedIndex !== -1) {
        this.props.onChange(this.calculateActualValue(index));
      } else {
        this.props.onChange(-1);
      }
    }
  };

  private calculateActualValue(i: number): number {
    return (this.props.end - (this.props.start + i)) + this.props.start;
  }

  private tempSection(className: string, color: string): ReactNode {
    return <svg className={className} xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 148.21 41.51">
      <rect y="-30" width="100%" height="100" style={{ fill: color }}/>
    </svg>;
  }

  private tempBottom(className: string, color: string): ReactNode {
    return <svg className={className} xmlns="http://www.w3.org/2000/svg" width="117" height="118.016" viewBox="0 0 117 118.016">
      <rect id="Rectangle_194" data-name="Rectangle 194" width="62" height="11.34" transform="translate(28)" style={{ fill: color }}/>
      <circle id="Ellipse_13" data-name="Ellipse 13" cx="58.5" cy="58.5" r="58.5" transform="translate(0 1.016)" style={{ fill: color }}/>
    </svg>;
  }

  render(): ReactNode {
    const { start, end, className } = this.props;
    const { selectedIndex } = this.state;
    const fullClassName = `tension-meter-scale ${className ? className : ''}`;
    const range = (end - start) + 1;

    const bottomColor = 'hsl(196, 100%, 35%)';
    return (
      <div className={fullClassName}>
        <div className="tension-meter-scale__container">
          <div className="tension-meter-scale__bar tension-meter-bar">
            {
              [...Array<number>(range)].map((_: any, i: number) => {
                const isSelected = selectedIndex <= i && selectedIndex !== -1;
                const selectedClassName = isSelected ? 'tension-meter-bar__section-container--selected' : '';

                return <div key={i} className={`tension-meter-bar__section-container ${selectedClassName}`} onClick={() => this.handleSelect(i)}>
                  {
                    this.tempSection(
                      'tension-meter-bar__section',
                      `${isSelected ? 'hsl(196, 100%, 35%)' : 'hsl(0, 0%, 96%)'}`
                    )
                  }
                  <div className="tension-meter-bar__section-number">{this.calculateActualValue(i)}</div>
                </div>;
              })
            }
            {
              this.tempBottom(
                'tension-meter-bar__bottom',
                bottomColor)
            }
          </div>
          <div className="tension-meter-scale__tips">
            <div>Zeer gespannen</div>
            <div>Licht gespannen</div>
            <div>Zeer ontspannen</div>
          </div>
        </div>
      </div>
    );
  }
}
